
import { useSyncExternalStore } from "react";

/* ─── Brand Colors (never change) ─── */
export const brandColors = {
  forestGreen: "#606b4c",
  sage: "#a8b58c",
  denimBlue: "#9baac9",
  cream: "#fff8ed",
  softLilac: "#ebe4ed",
  berryPink: "#f0a0a3",
  lavender: "#d5c5d8",
  blushPink: "#ffded5",
  tan: "#c9934c",
  navy: "#082d3d",
  // Intensified variants (same hue families, higher contrast for CTAs)
  berryRose: "#d4606a",
  denimRich: "#5d7ab0",
  tanDeep: "#b07a38",
  // Derived tints
  sageLight: "#d4dcc4",
  blushLight: "#fff0eb",
  lilacLight: "#f5eff6",
  warmCream: "#fef5e2",
};

/* ─── Semantic Palette Interface ─── */
export interface PaletteTheme {
  name: string;
  accent: string;
  accentSoft: string;
  warm: string;
  pop: string;
  blob1: string;
  blob2: string;
  blob3: string;
  sectionBg: string;
  sectionBg2: string;
}

/* ─── Palette Presets ─── */
export const palettes: PaletteTheme[] = [
  {
    name: "Warm & Bright",
    accent: brandColors.berryRose,
    accentSoft: brandColors.blushPink,
    warm: brandColors.tan,
    pop: brandColors.berryPink,
    blob1: brandColors.berryPink,
    blob2: brandColors.tan,
    blob3: brandColors.lavender,
    sectionBg: brandColors.softLilac,
    sectionBg2: brandColors.sageLight,
  },
  {
    name: "Garden",
    accent: brandColors.forestGreen,
    accentSoft: brandColors.sageLight,
    warm: brandColors.tan,
    pop: brandColors.berryPink,
    blob1: brandColors.lavender,
    blob2: brandColors.berryPink,
    blob3: brandColors.sage,
    sectionBg: brandColors.blushPink,
    sectionBg2: brandColors.softLilac,
  },
  {
    name: "Denim & Berry",
    accent: brandColors.denimRich,
    accentSoft: brandColors.lavender,
    warm: brandColors.berryRose,
    pop: brandColors.tan,
    blob1: brandColors.denimBlue,
    blob2: brandColors.berryPink,
    blob3: brandColors.lavender,
    sectionBg: brandColors.blushPink,
    sectionBg2: brandColors.cream,
  },
  {
    name: "Golden Hour",
    accent: brandColors.tanDeep,
    accentSoft: brandColors.blushPink,
    warm: brandColors.berryRose,
    pop: brandColors.forestGreen,
    blob1: brandColors.tan,
    blob2: brandColors.berryPink,
    blob3: brandColors.lavender,
    sectionBg: brandColors.softLilac,
    sectionBg2: brandColors.sageLight,
  },
];

/* ─── External Store ─── */
// Locked to "Warm & Bright". Switcher disabled.
const LOCKED_INDEX = 0;

let listeners: Array<() => void> = [];

export function setPalette(_index: number) {
  // no-op while palette is locked
}

function subscribe(_listener: () => void) {
  listeners = [...listeners, _listener];
  return () => {
    listeners = listeners.filter((l) => l !== _listener);
  };
}

function getSnapshot(): PaletteTheme {
  return palettes[LOCKED_INDEX];
}

function getPaletteIndex(): number {
  return LOCKED_INDEX;
}

export function usePalette(): PaletteTheme {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function usePaletteIndex(): number {
  return useSyncExternalStore(subscribe, getPaletteIndex, getPaletteIndex);
}
